import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationFaithSports from "../../../../src/content/faith-sports/donationHeader";
import "../../../../src/content/faith-sports/faith-sports.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationFaithSports,
  React
};